import { render, staticRenderFns } from "./orderCount.vue?vue&type=template&id=12d971fc&scoped=true"
import script from "./orderCount.vue?vue&type=script&lang=js"
export * from "./orderCount.vue?vue&type=script&lang=js"
import style0 from "./orderCount.vue?vue&type=style&index=0&id=12d971fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d971fc",
  null
  
)

export default component.exports